module.exports = "/_next/static/images/know-transfez-user-b76dbc219c28af8adb65b36c1de98a9d.svg";